// const API_BASE_URL = 'http://3.111.105.22:9000';
import {
    AUTH_BASE_URL,
    REDIRECT_URI
} from '../../utils/constants';

export const authService = {
    // Exchange code for tokens
    async exchangeCodeForTokens(code: string, codeVerifier: string) {
        const params = new URLSearchParams({
            grant_type: 'authorization_code',
            code: code,
            // redirect_uri: 'http://localhost:3000/callback',
            redirect_uri: REDIRECT_URI,
            code_verifier: codeVerifier,
            client_id: 'autopath-web',
        });

        const response = await fetch(`${AUTH_BASE_URL}/oauth2/token`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: params.toString(),
        });

        if (!response.ok) {
            const error = await response.text();
            throw new Error(`Token exchange failed: ${error}`);
        }
        return response.json();
    },

    // Refresh token
    async refreshTokens(refreshToken: string) {
        const params = new URLSearchParams({
            grant_type: 'refresh_token',
            refresh_token: refreshToken,
            client_id: 'autopath-web',
        });

        const response = await fetch(`${AUTH_BASE_URL}/oauth2/token`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: params.toString(),
        });

        if (!response.ok) {
            const error = await response.text();
            throw new Error(`Token refresh failed: ${error}`);
        }
        return response.json();
    },

    // Save tokens
    saveTokens(tokens: any) {
        localStorage.setItem('autopath_access_token', tokens.access_token);
        localStorage.setItem('autopath_refresh_token', tokens.refresh_token);
        localStorage.setItem('autopath_token_expiry', String(Date.now() + tokens.expires_in * 1000));
        if (tokens.id_token) {
            localStorage.setItem('autopath_id_token', tokens.id_token);
        }
    },

    // Get tokens
    getTokens() {
        return {
            accessToken: localStorage.getItem('autopath_access_token'),
            refreshToken: localStorage.getItem('autopath_refresh_token'),
            expiry: localStorage.getItem('autopath_token_expiry'),
            idToken: localStorage.getItem('autopath_id_token'),
        };
    },

    // Check if token is expired (with 1 minute buffer)
    isTokenExpired() {
        const expiry = localStorage.getItem('autopath_token_expiry');
        if (!expiry) return true;
        return Date.now() > parseInt(expiry) - 60000; // 1 minute buffer
    },

    // Get valid token (auto-refresh if needed)
    async getValidToken() {
        const tokens = this.getTokens();
        if (!tokens.accessToken || !tokens.refreshToken) return null;

        if (this.isTokenExpired()) {
            try {
                const newTokens = await this.refreshTokens(tokens.refreshToken);
                this.saveTokens(newTokens);
                return newTokens.access_token;
            } catch (error) {
                // console.error('Token refresh failed:', error);
                this.clearTokens();
                return null;
            }
        }
        return tokens.accessToken;
    },

    // Clear all tokens
    clearTokens() {
        // localStorage.removeItem('autopath_access_token');
        // localStorage.removeItem('autopath_refresh_token');
        // localStorage.removeItem('autopath_token_expiry');
        // localStorage.removeItem('autopath_id_token');
        // localStorage.removeItem('autopath_user');
        // localStorage.removeItem('profileData');

        localStorage.clear()
    }
};